export default __webpack_public_path__ + "static/media/sea.d9e29d6d.png";